
import {makeStyles} from '@material-ui/core/styles';
import { Colors } from '../../styles/Colors';
import { UAProfileKeyAction, UAProfileKeyActionConfiguration, UAProfileKeyPositionInfo } from '../../store/types/Devices';

export type DeviceProfileDetailsActionKeyRowData = {
    keyId: number;
    actions: string[];
    value: string;
    label: string;
    itemIdentifierInternal: string;
    selectedAction: string | undefined;
    position: UAProfileKeyPositionInfo;
    type: 'line_key' | 'soft_key' | 'expansion_key';
    isDisabled: boolean;
    actionsConfiguration: UAProfileKeyAction[];
    selectedActionConfiguration?: UAProfileKeyActionConfiguration[];
    line: number | null;
    maxLines: number;
    extrasOriginal?: string | null;
};

export type DeviceProfileDetailsActionKeyRowProps = {
    item: DeviceProfileDetailsActionKeyRowData;
    changeFunctionCallBack?: (item: DeviceProfileDetailsActionKeyRowData, newActionValue: string) => void;
    changeValueCallBack?: (item: DeviceProfileDetailsActionKeyRowData, newValue: string) => void;
    changeLabelCallBack?: (item: DeviceProfileDetailsActionKeyRowData, newLabelValue: string) => void;
    changeLineCallBack?: (item: DeviceProfileDetailsActionKeyRowData, newLineValue: number) => void;
    setActiveButton: (item: DeviceProfileDetailsActionKeyRowData) => void;
    onChange: (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | {}>,
    ) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errors?: any;
    readonly: boolean;
    activeButtonIdentifier: string | undefined;
};

export const useStyle = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        maxWidth: '676px',
        height: 80,
        width: '100%',
        overflowY: 'hidden',
        backgroundColor: Colors.SmokeBackground,
        marginBottom: 0,
        minHeight: 80,
    },
    iconButton: {
        marginTop: 16,
    },
    formFunction: {
        width: '156px !important',
        height: 58,
        marginLeft: 16,
        maxWidth: '156px !important',
        minWidth: 156,
    },
    fieldValue: {
        width: '180px !important',
        height: 58,
        marginLeft: 16,
        maxWidth: '180px !important',
        minWidth: 180,
    },
    fieldLine: {
        width: '88px !important',
        height: 58,
        marginLeft: 16,
        maxWidth: '88px !important',
        minWidth: 88,
        marginTop: -2,

        '& .MuiInputBase-input': {
            padding: '16px 8px 0 16px !important',
        },
    },
    fieldLabel: {
        width: '132px !important',
        height: 58,
        marginLeft: 16,
        maxWidth: '132px !important',
        minWidth: 132,
    }
}));
